import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import loc from '../../utils/loc';
import State from '../../context';
import Button from '../Button';

const PreResult = () => {
  const state = useContext(State);

  return (
    <Wrapper roundedBottom={!state.settings.paginated}>
      <Title>{loc.t('your results are')}</Title>
      <Button primary onClick={state.calculateResults}>{loc.t('show results')}</Button>
    </Wrapper>
  )
};

PreResult.propTypes = {
  onClick: PropTypes.func,
};

const Wrapper = styled.div`
  padding: 40px;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 31px;
  font-weight: bold;
  margin: 0 0 24px 0;
`;

export default PreResult;
